export const LIMIT = 50

export const SUB_ORDER_STATUS = {
    NEW: "NEW",
    PROCESSING: "PROCESSING",
    PAID: "PAID",
    ACCEPTED: "ACCEPTED",
    DELIVERY: "DELIVERY",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    RETURNED: "RETURNED",
}


export const FEATURE_CATEGORY = {
    "AI": "AI",
    "CRM": "CRM",
    "TEAM": "TEAM",
    "MESSAGING": "MESSAGING"
}

// Тип функционала. Может быть как лимитированным, так и безлимитным
export const FEATURE_TYPE = {
    "LIMIT": "LIMIT",
    "UNLIMITED": "UNLIMITED",
    "BOOLEAN": "BOOLEAN",
    "STORAGE": "STORAGE",
    "CUSTOM": "CUSTOM"
}

export const FEATURE_UNIT = {
    "REQUESTS": "REQUESTS",
    "GB": "GB",
    "USERS": "USERS",
    "MESSAGES": "MESSAGES",
    "LEADS": "LEADS",
    "REPORTS": "REPORTS"
}